import { z } from 'zod';
import { ProjectStatus, ProjectType } from '../enums';

export const ToolsProjects = z.object({
  id: z.string().uuid(),
  old_id: z.string().nullable().optional(),
  organization_id: z.string().uuid(),
  name: z.string(),
  url: z.string(),
  status: ProjectStatus,
  type: ProjectType,
  description: z.string().nullable(),
  with_diagnostic: z.boolean(),
  created_at: z.date({ coerce: true }),
  updated_at: z.date({ coerce: true }),
});

export type ToolsProjectsT = z.infer<typeof ToolsProjects>;

export const ToolsProjectsInsert = ToolsProjects.pick({
  name: true,
  organization_id: true,
}).required();

export type ToolsProjectsInsertT = z.infer<typeof ToolsProjectsInsert>;

export const ToolsProjectsUpdate = ToolsProjects.partial().omit({ id: true });

export type ToolsProjectsUpdateT = z.infer<typeof ToolsProjectsUpdate>;
